import type { SVGProps } from 'react';

export const InfoCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    stroke="#fff"
    viewBox="0 0 48 48"
    {...props}
  >
    <circle cx="24" cy="24" r="22" stroke="none" />
    <path
      fill="none"
      strokeLinecap="round"
      strokeWidth="4"
      d="M24 16h.02M24 22v10"
    />
  </svg>
);
